import React, { useState } from "react"

interface LeadStyleModalProps {
  isOpen: boolean
  onClose: () => void
  brandId: string
  currentValue?: "dominance" | "influencing" | "cautious" | "stabilizing"
  onSave: (
    brandId: string,
    leadStyle: "dominance" | "influencing" | "cautious" | "stabilizing",
  ) => Promise<void>
}

const LeadStyleModal: React.FC<LeadStyleModalProps> = ({
  isOpen,
  onClose,
  brandId,
  currentValue,
  onSave,
}) => {
  const [leadStyle, setLeadStyle] = useState<
    "dominance" | "influencing" | "cautious" | "stabilizing" | ""
  >(currentValue || "")
  const [isLoading, setIsLoading] = useState(false)

  const handleSave = async () => {
    if (!leadStyle) {
      return
    }
    setIsLoading(true)
    try {
      await onSave(brandId, leadStyle)
      onClose()
    } catch (error) {
      console.error("Error saving Lead Style:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const getLeadStyleLabel = (value: string) => {
    switch (value) {
      case "dominance":
        return "Dominant"
      case "influencing":
        return "Etkileyici"
      case "cautious":
        return "Dikkatli"
      case "stabilizing":
        return "Stabilize"
      default:
        return value
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed right-0 top-0 h-full z-50">
      <div className="bg-white h-full w-96 shadow-lg flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-xl font-semibold">Lead Style Düzenle</h2>
              <p className="text-sm opacity-90 mt-1">Marka ID: {brandId}</p>
            </div>
            <button onClick={onClose} className="text-white hover:text-gray-200">
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 p-4 overflow-y-auto">
          <div className="mb-4">
            <label htmlFor="leadStyle" className="block text-sm font-medium text-gray-700 mb-2">
              Lead Style
            </label>
            <select
              id="leadStyle"
              value={leadStyle}
              onChange={(e) =>
                setLeadStyle(
                  e.target.value as "dominance" | "influencing" | "cautious" | "stabilizing" | "",
                )
              }
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Lead Style seçin</option>
              <option value="dominance">Dominant</option>
              <option value="influencing">Etkileyici</option>
              <option value="cautious">Dikkatli</option>
              <option value="stabilizing">Stabilize</option>
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t p-4 bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-600">
              {leadStyle ? `Mevcut: ${getLeadStyleLabel(leadStyle)}` : "Değer seçilmemiş"}
            </div>
            <div className="flex gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
                disabled={isLoading}
              >
                İptal
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                disabled={isLoading || !leadStyle}
              >
                {isLoading ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeadStyleModal
